import React from "react";
import config from "../../../config.js";

export default function AdminModalFileUpload({
  isOpen,
  closeModal,
  modalData,
}) {
  if (!modalData) return null;

  const BASE_URL = config.cdnUrl;

  // فایل‌های جدیدی که بک‌اند برمی‌گرداند
  const files = Array.isArray(
    modalData.knowledgeFiles
  )
    ? modalData.knowledgeFiles
    : [];

  // اگر لوگو هم داخل فایل‌ها باشد، حذفش می‌کنیم
  const uploadedFiles = files.filter(
    (file) =>
      file?.url &&
      file.url !== modalData.logo
  );

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${isOpen ? "block" : "hidden"
        }`}
    >
      <div className="bg-white rounded-lg shadow-xl w-full max-w-[500px] p-6">

        {/* Header */}
        <div className="flex items-center justify-between border-b pb-3">

          <h2 className="text-lg font-bold text-[#1B4748]">
            فایل‌های آپلود شده
          </h2>

          <button
            onClick={closeModal}
            className="text-gray-500 hover:text-red-500 text-xl"
          >
            ×
          </button>

        </div>

        {/* Content */}
        <div className="mt-4">

          <p className="mb-4 text-gray-700">
            فایل های آپلود شده:{" "}
            <span className="font-bold">
              {uploadedFiles.length}
            </span>
          </p>

          {uploadedFiles.length > 0 ? (
            <div className="max-h-[300px] overflow-y-auto">

              {uploadedFiles.map(
                (file, index) => {
                  const fileUrl =
                    file.url || "";

                  const fileName =
                    fileUrl
                      .split("/")
                      .pop() || "فایل";

                  const parts =
                    fileName.split(".");

                  const extension =
                    parts.length > 1
                      ? parts.pop()
                      : "";

                  const name =
                    parts
                      .join(".")
                      .slice(0, 20);

                  return (
                    <a
                      key={
                        file.id ||
                        fileUrl ||
                        index
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${BASE_URL}${fileUrl}`}
                      download
                      className="flex items-center px-3 py-2 mb-2 rounded-md text-gray-600 hover:bg-gray-200 w-full transition"
                    >
                      <span>
                        {index + 1} -{" "}
                        {name}
                        {extension
                          ? `.${extension}`
                          : ""}
                      </span>
                    </a>
                  );
                }
              )}

            </div>
          ) : (
            <div className="text-center text-gray-500 py-8">
              فایلی برای این بات آپلود نشده است.
            </div>
          )}

        </div>

        {/* Footer */}
        <div className="flex justify-end mt-6 pt-4 border-t">

          <button
            onClick={closeModal}
            className="px-5 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-700 transition"
          >
            بستن
          </button>

        </div>

      </div>
    </div>
  );
}
